<template>
  <div class="stats-row">
    <div class="stats-range">
      <label>STATS RANGE</label>
      <ul>
        <li v-for="opt in options" :key="opt"
          :class="{ 'active': selectedRange === opt }"
          @click="changeDate(opt)"
        >
          {{ opt }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatOptions",

  props: {
    selectedRange: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      options: [
        'TD',
        'YD',
        '7D',
        '14D',
        '30D',
        'TW',
        'LW',
        'TM',
        'LM',
        'ALL'
      ]
    };
  },

  methods: {
    changeDate(value) {
      this.$emit('changeDate', value);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.stats-range {
  display: flex;

  label {
    font-weight: bold;
    text-transform: uppercase;
    color: #FFF;
    padding: 3px;
    padding-right: $spacing-base;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    background: $sec2;
    border-radius: 20px;
    height: 23px;

    li {
      float: left;
      font-size: 12px;
      color: #FFF;
      padding: 4px;
      width: 47px;
      text-align: center;
      border-radius: 20px;
      user-select: none;
      cursor: pointer;
    }

    .active {
      background: $blue
    }
  }
}
</style>